import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/404.png'


const _withScopeId = n => (_pushScopeId("data-v-e267a940"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "no-data" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "image",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_3 = { class: "tip" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.text || '暂无内容可用'), 1)
  ]))
}